import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import TileSelect from '@gcc/pip-components/dist/TileSelect';
import flow from 'lodash/flow';
import find from 'lodash/find';
import { TConfiguratorOption } from '../_propTypes';
import { OptionWrapper } from './styles';
import { onSelectedChoice } from '../../actions';
import { selectChoiceOptionById } from '../../selectors/selections';
import { selectDependentChoicesByOptionId } from '../../selectors/availableChoices';

const Tiles = ({ option }) => {
  const dispatch = useDispatch();
  const choiceSelection = useSelector(selectChoiceOptionById(option.id));
  const dependentChoices = useSelector(selectDependentChoicesByOptionId(option.id));

  return (
    <OptionWrapper>
      <Typography paragraph style={{ marginBottom: '4px' }}>
        {option.shortLabel}:&nbsp;<strong>{choiceSelection?.value}</strong>
      </Typography>
      <TileSelect
        options={dependentChoices}
        value={find(dependentChoices, { id: choiceSelection.id })}
        keyBy={(choice) => choice && choice.id}
        renderer={({ value }) => value && value.shortLabel}
        onChange={(choice) => dispatch(onSelectedChoice(choice))}
      />
    </OptionWrapper>
  );
};

Tiles.propTypes = {
  option: TConfiguratorOption.isRequired,
};

export default Tiles;